(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lb-casino/views/info-page.js') >= 0) return;  svs.modules.push('/modules/lb-casino/views/info-page.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.lb_casino=_svs.lb_casino||{};
_svs.lb_casino.templates=_svs.lb_casino.templates||{};
svs.lb_casino.templates.info_page = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = container.invokePartial(lookupProperty(partials,"components-casino-info_page-info_page"),depth0,{"name":"components-casino-info_page-info_page","data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"usePartial":true,"useData":true});
Handlebars.partials['svs-lb_casino-info_page'] = svs.lb_casino.templates.info_page;
})(svs, Handlebars);


 })(window);